<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-07-31 10:19:59
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-31 10:20:08
 * @FilePath: \partner.chaoyongtuan.com\src\views\cooperativeShop\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<router-view></router-view>
</template>

<script>
export default {
	name: 'index',
};
</script>

<style scoped></style>
